export const HOST_URL = process.env.VUE_APP_HOST_URL
export const API_URL = `${HOST_URL}laundry_management_api/`
